import { render, staticRenderFns } from "./CustomerBoard.vue?vue&type=template&id=f3986842&"
import script from "./CustomerBoard.vue?vue&type=script&lang=js&"
export * from "./CustomerBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports